import styled from 'styled-components'

export default styled.div`
  .lanes-tabs .ant-tabs-nav-list {
    width: 100%;
  }

  .lanes-tabs .ant-tabs-tab {
    flex: 1;
    justify-content: center;
    margin: 0;
  }
`
